var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.wrapperClasses, "vue-suggestion"] },
    [
      _c(
        "div",
        {
          class: [
            { vs__selected: _vm.value },
            _vm.inputWrapperClasses,
            "vs__input-group"
          ]
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchText,
                expression: "searchText"
              }
            ],
            class: [_vm.inputClasses, "vs__input"],
            attrs: {
              type: "search",
              placeholder: _vm.placeholder,
              disabled: _vm.disabled
            },
            domProps: { value: _vm.searchText },
            on: {
              blur: _vm.blur,
              focus: _vm.focus,
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchText = $event.target.value
                },
                _vm.inputChange
              ],
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.keyEnter($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.keyUp($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.keyDown($event)
                }
              ],
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "escape",
                    undefined,
                    $event.key,
                    undefined
                  )
                ) {
                  return null
                }
                return _vm.keyEscape($event)
              },
              dblclick: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
              }
            }
          }),
          _vm._v(" "),
          _vm._t("searchSlot")
        ],
        2
      ),
      _vm._v(" "),
      _vm.loading
        ? _vm._t("loading", [
            _c("div", { staticClass: "vs__loading" }, [_vm._v("Loading...")])
          ])
        : _vm.showList
        ? _vm._t("suggestionList", [
            _c(
              "div",
              { class: [_vm.suggestionListClasses, "vs__list"] },
              _vm._l(_vm.itemGroups, function(group, index) {
                return _c(
                  "div",
                  { key: index, class: _vm.suggestionGroupClasses },
                  [
                    _vm.itemGroups.length > 1 || group.header
                      ? _c(
                          "div",
                          {
                            class: [
                              _vm.suggestionGroupHeaderClasses,
                              "vs__group-header"
                            ]
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(group.header) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(group.items, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.vsItemIndex,
                          class: [
                            {
                              "vs__item-active": item.vsItemIndex === _vm.cursor
                            },
                            _vm.suggestionItemWrapperClasses,
                            "vs__list-item"
                          ],
                          on: {
                            click: function($event) {
                              return _vm.selectItem(item)
                            },
                            mouseover: function($event) {
                              _vm.cursor = item.vsItemIndex
                            }
                          }
                        },
                        [
                          _c(_vm.itemTemplate, {
                            tag: "div",
                            class: _vm.suggestionItemClasses,
                            attrs: { item: item }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              }),
              0
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }